"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Balance_reporter_abi__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "memberId",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "ETHQueueDeposit",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "memberId",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountRelatedToBuyingSlot",
                type: "uint256",
            },
        ],
        name: "FundsSentToDepositContract",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "memberId",
                type: "bytes",
            },
        ],
        name: "SpecialFeeApplied",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "DepositContract",
        outputs: [
            {
                internalType: "contract IDepositContract",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "WITHDRAWAL_CREDENTIALS",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "blsPublicKeyInternalNonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isCommonInterestCommitteeMember",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_member",
                type: "address",
            },
            {
                internalType: "bool",
                name: "_enabled",
                type: "bool",
            },
        ],
        name: "manageCommonInterestCommitteeMember",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_stakeHouse",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_memberId",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "_ethRecipient",
                type: "address",
            },
            {
                internalType: "address",
                name: "_freeFloatingSlotOwner",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "bytes",
                        name: "blsPublicKey",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "withdrawalCredentials",
                        type: "bytes",
                    },
                    {
                        internalType: "bool",
                        name: "slashed",
                        type: "bool",
                    },
                    {
                        internalType: "uint64",
                        name: "activeBalance",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "effectiveBalance",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "exitEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "activationEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "withdrawalEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "currentCheckpointEpoch",
                        type: "uint64",
                    },
                ],
                internalType: "struct ETH2Validation.ETH2DataReport",
                name: "_eth2Report",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint248",
                        name: "deadline",
                        type: "uint248",
                    },
                    {
                        internalType: "uint8",
                        name: "v",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "r",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "s",
                        type: "bytes32",
                    },
                ],
                internalType: "struct ETH2Validation.EIP712Signature[]",
                name: "_reportAndTokenHolderSignatures",
                type: "tuple[]",
            },
        ],
        name: "multipartyRageQuit",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_stakeHouse",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_memberId",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "_fullWithdrawalRecipient",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "bytes",
                        name: "blsPublicKey",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "withdrawalCredentials",
                        type: "bytes",
                    },
                    {
                        internalType: "bool",
                        name: "slashed",
                        type: "bool",
                    },
                    {
                        internalType: "uint64",
                        name: "activeBalance",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "effectiveBalance",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "exitEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "activationEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "withdrawalEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "currentCheckpointEpoch",
                        type: "uint64",
                    },
                ],
                internalType: "struct ETH2Validation.ETH2DataReport",
                name: "_eth2Report",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint248",
                        name: "deadline",
                        type: "uint248",
                    },
                    {
                        internalType: "uint8",
                        name: "v",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "r",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "s",
                        type: "bytes32",
                    },
                ],
                internalType: "struct ETH2Validation.EIP712Signature",
                name: "_signatureMetadata",
                type: "tuple",
            },
        ],
        name: "rageQuitKnot",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_stakeHouse",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_memberId",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "bytes",
                        name: "blsPublicKey",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "withdrawalCredentials",
                        type: "bytes",
                    },
                    {
                        internalType: "bool",
                        name: "slashed",
                        type: "bool",
                    },
                    {
                        internalType: "uint64",
                        name: "activeBalance",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "effectiveBalance",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "exitEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "activationEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "withdrawalEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "currentCheckpointEpoch",
                        type: "uint64",
                    },
                ],
                internalType: "struct ETH2Validation.ETH2DataReport",
                name: "_eth2Report",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint248",
                        name: "deadline",
                        type: "uint248",
                    },
                    {
                        internalType: "uint8",
                        name: "v",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "r",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "s",
                        type: "bytes32",
                    },
                ],
                internalType: "struct ETH2Validation.EIP712Signature",
                name: "_signatureMetadata",
                type: "tuple",
            },
        ],
        name: "slash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_stakeHouse",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_memberId",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "_slasher",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_buyAmount",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "bytes",
                        name: "blsPublicKey",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "withdrawalCredentials",
                        type: "bytes",
                    },
                    {
                        internalType: "bool",
                        name: "slashed",
                        type: "bool",
                    },
                    {
                        internalType: "uint64",
                        name: "activeBalance",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "effectiveBalance",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "exitEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "activationEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "withdrawalEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "currentCheckpointEpoch",
                        type: "uint64",
                    },
                ],
                internalType: "struct ETH2Validation.ETH2DataReport",
                name: "_eth2Report",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint248",
                        name: "deadline",
                        type: "uint248",
                    },
                    {
                        internalType: "uint8",
                        name: "v",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "r",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "s",
                        type: "bytes32",
                    },
                ],
                internalType: "struct ETH2Validation.EIP712Signature",
                name: "_signatureMetadata",
                type: "tuple",
            },
        ],
        name: "slashAndTopUpSlot",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "specialExitFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "stakeHouseMemberQueue",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_memberId",
                type: "bytes",
            },
        ],
        name: "topUpKNOT",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_stakeHouse",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_memberId",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "_recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "topUpSlashedSlot",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "universe",
        outputs: [
            {
                internalType: "contract StakeHouseUniverse",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_stakeHouse",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_memberId",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "bytes",
                        name: "blsPublicKey",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "withdrawalCredentials",
                        type: "bytes",
                    },
                    {
                        internalType: "bool",
                        name: "slashed",
                        type: "bool",
                    },
                    {
                        internalType: "uint64",
                        name: "activeBalance",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "effectiveBalance",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "exitEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "activationEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "withdrawalEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "currentCheckpointEpoch",
                        type: "uint64",
                    },
                ],
                internalType: "struct ETH2Validation.ETH2DataReport",
                name: "_eth2Report",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint248",
                        name: "deadline",
                        type: "uint248",
                    },
                    {
                        internalType: "uint8",
                        name: "v",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "r",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "s",
                        type: "bytes32",
                    },
                ],
                internalType: "struct ETH2Validation.EIP712Signature",
                name: "_signatureMetadata",
                type: "tuple",
            },
        ],
        name: "voluntaryWithdrawal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class Balance_reporter_abi__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Balance_reporter_abi__factory = Balance_reporter_abi__factory;
Balance_reporter_abi__factory.abi = _abi;
